@import '../../../../style/src/typography/mixins';
@import '../../mixins/outline';

:host {
	@include zds-typography('body');

	display: inline-block;
	font-size: inherit;
	line-height: inherit;
}

::slotted([slot='icon']) {
	.zds-link--icon-end &,
	.zds-link--icon-start & {
		position: relative;
		top: -1px;
		vertical-align: middle;
	}

	.zds-link--icon-bottom & {
		margin-top: var(--zds-space-2);
	}

	.zds-link--icon-end & {
		margin-left: var(--zds-space-2);
	}

	.zds-link--icon-start & {
		margin-right: var(--zds-space-2);
	}

	.zds-link--icon-top & {
		margin-bottom: var(--zds-space-2);
	}
}

// zds-icon components specifically need 1px extra offset
::slotted(zds-icon) {
	.zds-link.zds-link--icon-end &,
	.zds-link.zds-link--icon-start & {
		top: -2px;
	}
}

.zds-link {
	@include outline;

	--zds-outline-color: currentcolor;

	align-items: center;
	color: var(--zds-link-color);
	cursor: pointer;
	display: flex;
	margin-block: calc(-1 * var(--zds-space-2));
	padding-block: var(--zds-space-2);
	text-decoration: var(--zds-link-text-decoration);
	width: 100%;

	&:visited {
		color: var(--zds-link-color-visited);
	}

	&:hover {
		color: var(--zds-link-color-hover);
		cursor: pointer;
	}

	&--inherit {
		&,
		&:hover,
		&:visited {
			color: inherit;
		}
	}

	&--loud {
		text-decoration: underline;

		&:hover {
			text-decoration: none;
		}
	}

	&--icon {
		&-bottom,
		&-end,
		&-top {
			align-items: center;
			display: inline-flex;
		}

		&-bottom {
			flex-direction: column-reverse;
		}

		&-end {
			flex-direction: row-reverse;
		}

		&-top {
			flex-direction: column;
		}
	}

	&__icon,
	&__label {
		display: block;
	}

	&:hover .zds-link__label {
		text-decoration: var(--zds-link-text-decoration-hover);
	}
}
